import { SetPropertyValueOptions } from "../../eaiws/basket";
import { PropertyChangedResult } from "../../core/prop";
import { ListenableEvent } from "../../utils";
import { ArticlePropertyHelpers } from "../../cf";
/** @internal */
export class ArticlePropertyProvider {
    constructor(pBasket, pMultiProvider, pArticle) {
        this.eventPropertiesChanged = new ListenableEvent(this);
        this.onSetPropertyValue = async (pEaiProperty, pValue) => {
            if (pEaiProperty == null)
                return (PropertyChangedResult.Nothing);
            let tStrValue = "";
            if (pValue != null)
                tStrValue = pValue.toString();
            //no need to set same value again
            if (tStrValue === pEaiProperty.value.value)
                return (PropertyChangedResult.Nothing);
            //set value on EAIWS
            try {
                const tOptions = new SetPropertyValueOptions();
                tOptions.computeVisibilityChangeFlags = false;
                tOptions.computeChoiceListChangeFlags = false;
                const tResult = await this.mBasket.session.basket.setPropertyValue(this.mArticle.id, pEaiProperty.propClass, pEaiProperty.propName, tStrValue, tOptions);
                if (tResult != null && tResult !== "U") { //"U" means nothing changed
                    //r = item removed, a = item added
                    const tNeedParentUpdate = tResult.indexOf("r") !== -1 || tResult.indexOf("a") !== -1;
                    this.mMultiProvider._notifyMainArticleChanged(this.mArticle.getMainArticle(), tNeedParentUpdate);
                    this.eventPropertiesChanged.trigger(PropertyChangedResult.Properties);
                    return (PropertyChangedResult.Properties);
                }
            }
            catch (pError) {
                this.mMultiProvider.eventSetPropValueError.trigger(pError);
            }
            return (PropertyChangedResult.Nothing);
        };
        this.mBasket = pBasket;
        this.mMultiProvider = pMultiProvider;
        this.mArticle = pArticle;
    }
    async getProperties() {
        const tArticleData = await this.mArticle._getArticleData();
        return (ArticlePropertyHelpers.GetProperties(this.mArticle.id, this.mBasket.session, this, tArticleData, this.onSetPropertyValue));
    }
    async getPropertyClasses() {
        const tArticleData = await this.mArticle._getArticleData();
        return (ArticlePropertyHelpers.GetPropertyClasses(tArticleData));
    }
    beginPropertyChange() {
    }
    endPropertyChange() {
    }
}
